import { toState } from '../base/redux/functions';
import { SHARED_BROWSER, ALLOWED_PROTOCOLS } from './constants';
export function isBrowserShared(stateful) {
    const state = toState(stateful);
    return state['features/shared-browser']?.isOpen;
}
export function isSharedBrowserOwner(stateful, participantId) {
    const state = toState(stateful);
    return state['features/shared-browser']?.ownerId === participantId;
}
export function normalizeUrl(input) {
    if (!input) {
        return '';
    }
    let trimmed = input.trim();
    if (!/^https?:\/\//i.test(trimmed)) {
        // Check if it's a search query (no dots or contains spaces)
        if (trimmed.indexOf(' ') !== -1 || trimmed.indexOf('.') === -1) {
            // Use DuckDuckGo Lite (HTML only) to bypass frame-busting JavaScript that causes blank screens
            return `https://lite.duckduckgo.com/lite/?q=${encodeURIComponent(trimmed)}`;
        }
        trimmed = `https://${trimmed}`;
    }
    try {
        const urlObj = new URL(trimmed);
        return urlObj.toString();
    }
    catch (_) {
        return '';
    }
}
export function validateBrowserUrl(url) {
    if (!url)
        return false;
    try {
        const urlObj = new URL(url);
        return ALLOWED_PROTOCOLS.includes(urlObj.protocol.toLowerCase());
    }
    catch (_) {
        return false;
    }
}
export function sendSharedBrowserCommand({ conference, commandType, sessionId, url, navigationVersion, ownerId, scrollX, scrollY }) {
    conference?.sendCommandOnce(SHARED_BROWSER, {
        value: commandType,
        attributes: {
            sessionid: sessionId,
            url: url || '',
            version: navigationVersion,
            ownerid: ownerId,
            scrollx: scrollX ?? 0,
            scrolly: scrollY ?? 0
        }
    });
}
